"use client";

import Image from "next/image";
import React from "react";

export default function MachineOverview(props) {
  const machine = props.data;
  return (
    <div className="machine-overview">
      <Image
        src={machine.machine_overview.data.attributes.url}
        width={1920}
        height={1080}
        alt={
          machine.machine_overview.data.attributes.alternativeText ||
          "FactoryCat Floor Scrubbers"
        }
      />
    </div>
  );
}
